import { SecondaryLayout } from "app/widgets/secondary-layout";
import type { FC, PropsWithChildren } from "react";

import type { AppLayout } from "~/core";
import {
  isLayoutV2,
  isSecondaryLayout,
} from "~/core/utils/layout-guards.utils";
import { MainLayoutV2 } from "~/widgets/main-layout-v2";

type AppLayoutProps = PropsWithChildren<{ layoutData: AppLayout }>;
export const AppLayoutWidget: FC<AppLayoutProps> = ({
  layoutData,
  children,
}) => {
  if (!layoutData) {
    return <>{children}</>;
  }

  if (isLayoutV2(layoutData)) {
    return <MainLayoutV2 data={layoutData}>{children}</MainLayoutV2>;
  }

  if (isSecondaryLayout(layoutData)) {
    return <SecondaryLayout data={layoutData}>{children}</SecondaryLayout>;
  }
  return <>{children}</>;
};
